export default __webpack_public_path__ + "static/media/chats_icon_light.8d5dd4eb.svg";